import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { showAlert } from 'actions/app';
import { getBulkEmailSignature } from 'services/bulkEmail';

export const useEmailSignature = () => {
  const [signature, setSignature] = useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
    let isMounted = true;

    (async () => {
      const response = await getBulkEmailSignature();
      if (!isMounted) return;

      if (response.success) {
        setSignature(response.data.emailSignature);
      } else {
        dispatch(showAlert(response.alert));
      }
    })();

    return () => {
      isMounted = false;
    };
  }, [dispatch]);

  return { signature };
};
